import { baseURL } from "./endPoints";
import toastHelper from "../../utilities/toastHelper";
import axios from "axios";
import { clearLocalStorage } from "../../utilities/mixin";

// Create Axios instance
const api = axios.create({
    baseURL,
});

// Request Interceptor
api.interceptors.request.use(
    (config) => {
        // If data is not FormData, set Content-Type
        if (!(config.data instanceof FormData)) {
            config.headers["Content-Type"] = "application/json";
        } else {
            delete config.headers["Content-Type"];
        }

        // Add Authorization token
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error),
);

// Response Interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            const currentUrl = window.location.pathname;
            // ============ 401 Handling ============
            if (status === 401) {
                clearLocalStorage();
                // Case 1: Login page ? wrong username or password
                if (currentUrl === "/" || currentUrl.includes("login")) {
                    return Promise.reject(error);
                }
                // Case 2: Any other page ? token expired, redirect to login 
                window.location.href = "/login";
                return Promise.reject(error);
            }

            // Handle other errors
            if (status !== 422 && status !== 400) {
                const errorMessage =
                    data.message ||
                    data.error ||
                    "Something went wrong. Please try later.";
                // Show toast for all other pages
                toastHelper.error(errorMessage);
                return Promise.reject(error);
            } else {
                if (data && data.title) {
                    toastHelper.error(data.title);              
                }
                return Promise.reject(error);
            }
        } else if (error.request) {
            toastHelper.error("Network error. Please check your connection.");
            return Promise.reject(error);
        } else {
            toastHelper.error("Unexpected error occurred.");
            return Promise.reject(error);
        }
    },
);

export default api;
